export default __webpack_public_path__ + "static/media/kristina_savova_xl.1a8fbed8.jpg";